import React from 'react';

const Home: React.FC = () => {
  return (
    <div>
      <h1>Welcome to Yomunami</h1>
      <p>Select an option from the sidebar to get started.</p>
    </div>
  );
};

export default Home;

